import { ProcessorSwitch } from '../../atoms/processor-switch';
import { ManualCardEntryJustifi } from './manual-card-entry-justifi';
import { ManualCardEntryStripe } from './manual-card-entry-stripe';

export const ManualCardEntrySwitch = () => {
  return <ProcessorSwitch stripeContent={ManualCardEntryStripe} justifiContent={ManualCardEntryJustifi} />;
};
